import { tns } from '../../../../../build/node_modules/tiny-slider/src/tiny-slider';
export class Slider {
    constructor() {
        this.init();
    }

    init() {
        // Store gallery
        let galleryContainer = document.querySelector('.store-gallery');
        if(galleryContainer) {
            let slider = tns({
                container: '.store-gallery',
                mode: 'carousel',
                items: 1,
                autoplay: true,
                controls: false,
                controlsContainer: false,
                navContainer: '.store-gallery_nav',
                autoplayButtonOutput: false,
                mouseDrag: true
            });
            slider.play();
        }
    }
}